import { useEffect, useMemo, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { WebLayout } from "../../components/web-layout";

import Handler from "./handler";

const useQueryParams = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
};

export default function ExternalLoginHandler() {
    const queryParams = useQueryParams();
    const [source] = useState<string | null>(queryParams.get("source"));
    const { t } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
        if (!source) {
            navigate("/");
        }
    }, [navigate, source]);

    if (source) {
        return <Handler source={source} />;
    }

    return (
        <WebLayout>
            <Row className="align-items-center justify-content-center">
                <Col xs="auto">
                    <Spinner animation="border" variant="secondary" />
                </Col>
                <Col xs="auto" className="pl-1">
                    <h4 className="my-0">{t("loading")}...</h4>
                </Col>
            </Row>
        </WebLayout>
    );
}
